import { CloudTypeEnum, useAccountId } from '@labrav/common'
import type { CloudMarketplace } from '../../modules/productsListing/types'

/** Search ranking / marketplace SEO is AWS-only. */
export const SEO_CLOUD_MARKETPLACE: CloudMarketplace = 'AWS'

export const seoCloudSelectorOptions = [
  { name: 'AWS', disabled: false },
  { name: 'AZURE', disabled: true },
  { name: 'GCP', disabled: true },
]

/** Always resolve the FLYOUT AWS account (route param or AWS selection), never MSF/other clouds. */
export const useSeoAccountId = (): string =>
  useAccountId({ product: 'flyout', cloud: CloudTypeEnum.AWS }) || ''
